import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-view-geolocation',
  templateUrl: './view-geolocation.component.html',
  styleUrls: ['./view-geolocation.component.css']
})
export class ViewGeoLocationComponent implements OnInit {
  public branchInformation = [];
  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  serchKey = 'branchName'
  noDataEnable: boolean = false;
  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert) { }

  ngOnInit(): void {
    this.getBranchList();
  }
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.noDataEnable = true
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  editBranchData(data){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/geolocation/edit-geolocation', data.branchID ]);
  }
}
